import React, { useEffect, useMemo, useState } from 'react';
import Classes from './styles/style.module.css';
import { motion } from 'framer-motion';
import { usePreventScrolling } from '../../../../../../../../Hooks/usePreventScrolling';
import { CloseIcon } from '../../../../../../../../utils/Icons';
import backend from '../../../../../../../../api';
import { useSelector } from 'react-redux';

export default function ReschedulePopup({ booking, closePopup, submitPopup, busy }) {
  const { token } = useSelector((s) => s?.auth || {});
  const [date, setDate] = useState(booking?.appointment?.date || '');
  const [slots, setSlots] = useState([]);
  const [timeSlot, setTimeSlot] = useState(booking?.appointment?.timeSlot || '');
  const [note, setNote] = useState('');
  const [loadingSlots, setLoadingSlots] = useState(false);

  usePreventScrolling();

  async function loadSlots(d) {
    if (!d || !booking?.companyId) { setSlots([]); return; }
    setLoadingSlots(true);
    try {
      const { data } = await backend.get(
        `/api/services/by-company/${booking.companyId}/slots`,
        { params: { date: d } }
      );
      const arr = data?.data?.slots || [];
      setSlots(arr);
      // preserve current timeSlot if still valid, else clear
      setTimeSlot((prev) => (arr.includes(prev) ? prev : ''));
    } catch (e) {
      console.error('load slots error', e);
      setSlots([]);
      setTimeSlot('');
    } finally {
      setLoadingSlots(false);
    }
  }

  useEffect(() => { loadSlots(date); /* eslint-disable-next-line */ }, [date]);

  const handleSubmit = (e) => {
    e?.preventDefault?.();
    if (!date) return alert("Choose a date");
    if (!timeSlot) return alert("Choose a time slot");
    submitPopup?.({ date, timeSlot, note });
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.2 }} className={Classes.popup} onClick={closePopup}>
      <motion.div initial={{ y: 7 }} animate={{ y: 0 }} exit={{ y: 7 }} transition={{ duration: 0.25 }}
        className={Classes.card} onClick={(e) => e.stopPropagation()}>
        <div className={Classes.close} onClick={closePopup}>
          <CloseIcon height='20px' fill='white' />
        </div>

        <div className={Classes.bgPopup}>
          <div></div>
          <h5 className={Classes.title}>Change Appointment</h5>
          <div className={Classes.curveCon}></div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className={Classes.cardCon}>
            <div className={Classes.flexColGroup}>
              <div className={Classes.flexCol1}>
                <h5 className={Classes.label}>New Appointment Date</h5>
                <input
                  type="date"
                  className={Classes.inputField}
                  required
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>
            </div>

            <div className={Classes.flexColGroup}>
              <div className={Classes.flexCol1}>
                <h5 className={Classes.label}>Available 30 minutes Slots</h5>
                {loadingSlots ? (
                  <div className={Classes.text}>Loading...</div>
                ) : slots.length === 0 ? (
                  <div className={Classes.text}>No slots available for this date.</div>
                ) : (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(120px,1fr))', gap: 8 }}>
                    {slots.map((s) => (
                      <button
                        type="button"
                        key={s}
                        onClick={() => setTimeSlot(s)}
                        className={timeSlot === s ? Classes.slotBtnActive : Classes.slotBtn}
                        style={{
                          border: '1px solid #e5e7eb',
                          borderRadius: 8,
                          padding: '8px 10px',
                          background: timeSlot === s ? 'rgba(23,43,67,0.1)' : '#fff',
                        }}
                      >
                        {s}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className={Classes.flexColGroup}>
              <div className={Classes.flexCol1}>
                <div className='flexAlign10'>
                  <h5 className={Classes.label}>Message to Fuel Clubs</h5>
                  <div className={Classes.optionalText}><h5>Optional</h5></div>
                </div>
                <div className={Classes.textAreaCon}>
                  <textarea
                    rows={4}
                    name="notes"
                    placeholder='Start typing...'
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className={Classes.flexAlign}>
              <button type="button" onClick={closePopup} className={Classes.btn1} disabled={busy}>
                <h5>Back</h5>
              </button>
              <button type="button" onClick={handleSubmit} className={Classes.btn2} disabled={busy || !date || !timeSlot}>
                <h5>Confirm</h5>
              </button>
            </div>
          </div>
        </form>
      </motion.div>
    </motion.div>
  );
}
